export const fonts = {
    heroNew: "'Hero New', arial, sans-serif",
    heroNewMedium: "'Hero New', arial, sans-serif",
};
